<script>
  import Logo from "../images/Logo.svelte"
</script>

<footer class="text-end px-3 py-3">
  <span class="mt-3 mb-0 fg-secondary small">
    Sistema de Búsquedas Integradas - 2025 |
  </span>
  <a
    class="small text-decoration-none mt-0 py-0"
    href="https://www.domaware.mx/terminos-y-condiciones-SBI"
    target="_blank"
    rel="noopener noreferrer"
  >
    Términos y Condiciones
  </a>
</footer>
